import React from 'react';
import loadable from '@loadable/component';

const LoadableComponent = loadable(() =>
  import(/* webpackChunkName: "graph" */ './price-prediction')
);

const PricePredictionLoader = props => <LoadableComponent {...props} />;

export default PricePredictionLoader;
